import { ReactElement, MouseEvent } from "react";
import { NavLink } from "react-router-dom";
import { TooltipSetup } from "../../../../hooks/UseTooltip";
import { IComponent } from "../../../../services/http/component/models/IComponent";
import StatusIndicator from "../../StatusIndicator";
import styles from "./ComponentItem.module.scss";

interface ComponentItemProps
{
    component: IComponent;
    setupTooltip: (x: TooltipSetup) => void;
    allowTooltips: boolean;
    tooltipClass?: string;
    noLink?: boolean;
}

const ComponentItem = (props: ComponentItemProps): ReactElement => {

    const prevent = (e: MouseEvent): void =>
    {
        e.preventDefault();
    }
    
    function handleMouseEnter(event: MouseEvent): void
    {
        if (!props.allowTooltips) return
        const { x, y } = event.currentTarget.getBoundingClientRect();

        props.setupTooltip({
            position: { x: x + 15, y },
            customClassName: props.tooltipClass,
            content: props.component.name
        })
    }
    if (!props.noLink)
    {
        return (
        <NavLink
            to={`/dashboard/${props.component.id}`}
            className={styles.componentItem}
            onMouseEnter={e => handleMouseEnter(e)}
        >
            <span className={styles.componentName}>{props.component.name}</span>

            <StatusIndicator customClassName={styles.status} component={props.component} />
        </NavLink>)
    }
    else
    {
        return (
        <NavLink
            to={`/dashboard/${props.component.id}`}
            className={styles.componentItemNoClick}
            onMouseEnter={e => handleMouseEnter(e)}
            onClick={prevent}
        >
            <span className={styles.componentName}>{props.component.name}</span>

            <StatusIndicator customClassName={styles.status} component={props.component} />
        </NavLink>)
    }
};

export default ComponentItem;
